import { useState, useCallback } from 'react';

import { getCookie } from '../../../api/HelperAPI';

export const usePostApi = ({ endpoint }) => {
    const [isLoading, setLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [status, setStatus] = useState();
    const [payload, setPayload] = useState();

    const fetchData = useCallback(
        async (data) => {
            setLoading(true);

            // eslint-disable-next-line iwoca/prefer-lapi-client
            const response = await fetch(endpoint, {
                method: 'POST',
                body: JSON.stringify(data),
                mode: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': getCookie('csrftoken')
                }
            });
            const responseStatus = response.status;
            setStatus(responseStatus);

            let responsePayload;
            try {
                responsePayload = await response.json();
            } catch (error) {
                setHasError(true);
                setLoading(false);
                responsePayload = error;
                return {
                    hasError: true,
                    payload: undefined,
                    status: responseStatus
                };
            }
            setPayload(responsePayload);

            if (!response.ok) {
                setHasError(true);
                setLoading(false);
                return {
                    hasError: true,
                    payload: undefined,
                    status: responseStatus
                };
            }

            setLoading(false);
            return {
                payload: responsePayload,
                hasError: false,
                status: responseStatus
            };
        },
        [endpoint]
    );

    return {
        isLoading,
        status,
        payload,
        hasError,
        triggerFetch: fetchData
    };
};
